import type { MessageStruct } from './messages'

export const enMessages: MessageStruct = {
  role: {
    ADMIN: 'Admin',
    LEADER: 'Leader',
    MANAGER: 'Project Manager',
    VIEWER_MEMBER: 'Viewer',
    MEMBER: 'Member'
  },
  costPeriod: {
    MONTHLY: 'Monthly',
    DAILY: 'Daily',
    HOURLY: 'Hourly',
    null: ''
  },
  dayOfWeek: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },
  stageManager: {
    title: 'Changes',
    discardAll: 'Discard all changes',
    message: {
      notSaved: 'Changes have not been saved yet.',
      saveInstruction:
        'To save, please describe the intent of the changes and press the save button.'
    },
    placeholder: 'Describe reason/intent for changes',
    save: 'Save',
    processing: 'Processing...',
    error: 'Failed to update data. Please try again.'
  },
  customField: {
    STRING: 'String',
    NUMBER: 'Number',
    DATETIME: 'Date',
    CHOSE_SINGLE: 'Single Choice',
    CHOSE_MULTIPLE: 'Multiple Choice'
  },
  stages: {
    icon: {
      attendance: 'edit_calendar',
      work_on_project: 'edit_calendar',
      project: 'description',
      user: 'people_alt',
      employment: 'people_alt',
      assign: 'format_list_bulleted',
      assign_plan: 'format_list_bulleted',
      volumed_assign: 'format_list_bulleted',
      volumed_assign_plan: 'format_list_bulleted',
      target_cost_other: 'attach_money',
      target_cost_other_actual: 'attach_money',
      department: 'settings',
      client: 'settings',
      partner: 'settings',
      job_title: 'settings',
      job_skill: 'settings',
      custom_field: 'settings',
      custom_field_choice: 'settings',
      holiday: 'settings',
      regular_holiday: 'settings',
      setting: 'settings'
    },
    table: {
      attendance: 'Attendance',
      work_on_project: 'Time Tracking',
      project: 'Projects',
      project_to_department: 'Assigned Depts',
      project_to_user: 'Project Manager',
      user: 'Personnel',
      employment: 'Contracts',
      department: 'Departments',
      assign: 'Assignments',
      assign_plan: 'Assignment Plans',
      volumed_assign: 'TBD Assignments',
      volumed_assign_plan: 'TBD Plans',
      volumed_assign_to_job_skill: 'Required Skills',
      volumed_assign_to_department: 'TBD Departments',
      target_cost_other: 'Other Costs',
      target_cost_other_actual: 'Other Costs Actual',
      client: 'Clients',
      partner: 'Partners',
      job_title: 'Job Titles',
      job_skill: 'Skills',
      custom_field: 'Custom Fields',
      custom_field_choice: 'Choices',
      holiday: 'Holidays',
      regular_holiday: 'Regular Holidays',
      setting: 'System Settings'
    },
    actions: {
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      order: 'Order'
    },
    labels: {
      attendance: { clocks: 'Work Time' },
      work_on_project: {
        actuals: 'Actual Time',
        comments: 'Comment'
      },
      project: {
        name: 'Project Name',
        code: 'Code',
        start_date: 'Start',
        end_date: 'End',
        target_sales: 'Target Sales (JPY)',
        client_id: 'Client',
        detail: 'Description',
        custom_fields: 'Custom Fields',
        target_cost: 'Target Cost(JPY)',
        target_man_month: 'Target M/M',
        target_man_hours_in_sec: 'Target Hours',
        userIds: 'Members',
        departmentIds: 'Departments',
        target_sales_breakdown_plan: 'Monthly Sales'
      },
      error: {
        required: 'Required',
        invalidDate: 'Please enter a valid date (YYYY-MM-DD).',
        max30Items: 'Must be 30 items or less',
        max30Users: 'Must be 30 users or less',
        max10Departments: 'Must be 10 departments or less',
        min2Chars: 'Please enter at least 2 characters.',
        max128Chars: 'Please enter no more than 128 characters.',
        alphanumeric: 'Please enter alphanumeric characters and symbols',
        codeExists: 'That code is already in use',
        endDateAfterStartDate: 'End date must be after start date',
        within5Years: 'Period must be within 5 years',
        workResultOutsidePeriod: 'Work results exist outside the period',
        invalidItemIncluded: 'Contains invalid items',
        zod: {
          offsetNegative: 'Please enter an integer 0 or greater.',
          endDateAfterStartDate: 'End date must be after start date.'
        },
        user: {
          nameTooLong: 'Please enter no more than 32 characters.',
          nameTooShort: 'Please enter at least 2 characters.',
          emailTooLong: 'Please enter no more than 128 characters.',
          invalidEmail: 'Please enter a valid email address.',
          higherRole: 'Cannot set a higher role than your own.',
          noteTooLong: 'Please enter no more than 5000 characters.',
          notInteger: 'Please enter an integer.',
          displayOrderNegative: 'Please enter a number 0 or greater.',
          duplicateEmail: 'This email address is already in use.',
          max10Department: 'Must be 10 items or less.',
          max30JobTitle: 'Must be 30 items or less.',
          max160JobSkill: 'Must be 160 items or less.'
        },
        password: {
          minLength: 'Please enter at least 8 characters.',
          maxLength: 'Please enter no more than 128 characters.',
          requiredTypes:
            'Please enter at least 3 character types: uppercase letters, lowercase letters, numbers, and symbols ({{symbol}}).',
          mismatch: 'Passwords do not match.'
        },
        tenant: {
          formatError: 'Please enter in HH:MM-HH:MM format.',
          rangeError: 'End time must be after start time.',
          breakRangeError: 'Break time must be within work time.',
          dailyWorkTime: 'Please enter between 00:01 - 23:59.',
          thresholdLength: 'Thresholds must be specified as 4 integers.',
          thresholdOrder: 'Thresholds must be in ascending order.',
          thresholdDuplicate: 'Thresholds cannot have duplicates.'
        },
        employment: {
          invalidStartDate: 'Please enter a year between 1980 and 2099.',
          costMustBeInteger: 'Only integers can be entered.',
          costNegative: 'Please enter 0 or greater.',
          costTooLarge: 'Please enter 9,999,999 or less.',
          duplicateStartMonth: 'This start month is already set.'
        }
      },
      user: {
        name: 'Name',
        email: 'Email',
        role: 'System Role',
        departmentIds: 'Departments',
        jobTitleIds: 'Roles',
        jobSkillIds: 'Skills',
        note: 'Note',
        available: 'Status',
        display_order: 'Order'
      },
      employment: { start: 'Start', partner_id: 'Affiliation', type: 'Type', cost: 'Rate' },
      assign: {
        visible: 'Assign',
        comment: 'Comment',
        icon: 'Icon',
        user_id: 'Personnel'
      },
      assign_plan: {
        start_offset: 'Start',
        end_offset: 'End',
        estimate: 'Work Time/Day',
        plan_start_date: 'Start',
        plan_end_date: 'End'
      },
      volumed_assign: {
        job_title_id: 'Job Title',
        jobSkillIds: 'Skills',
        departmentIds: 'Department',
        comment: 'Comment',
        icon: 'Icon'
      },
      volumed_assign_plan: {
        start_offset: 'Start',
        end_offset: 'End',
        estimate: 'Work Time/Day',
        plan_start_date: 'Start',
        plan_end_date: 'End'
      },
      volumed_assign_to_department: {
        department_id: 'Department'
      },
      target_cost_other: { name: 'Name', costs_plan: 'Amount' },
      target_cost_other_actual: {
        name: 'Name',
        month: 'Month',
        cost: 'Cost',
        costs_actual: 'Amount'
      },
      department: { name: 'Name', order: 'Order' },
      client: { name: 'Name', order: 'Order' },
      partner: { name: 'Name', order: 'Order' },
      job_title: { name: 'Name', choosable: 'Status', order: 'Order' },
      job_skill: { name: 'Name', choosable: 'Status', order: 'Order' },
      custom_field: {
        name: 'Label',
        key: 'Key',
        description: 'Desc',
        value_type: 'Type',
        required: 'Req',
        visible: 'Status'
      },
      custom_field_choice: {
        name: 'Name',
        key: 'Key',
        visible: 'Status',
        order: 'Order'
      },
      holiday: { name: 'Name', date: 'Date' },
      regular_holiday: { year: 'Year', day_of_week: 'Weekday', day_off: 'Holiday?' },
      setting: { settings: 'Settings' }
    }
  },
  changeType: {
    insert: 'Insert',
    update: 'Update',
    delete: 'Delete',
    maintenance_insert: 'Sys Insert',
    maintenance_update: 'Sys Update',
    maintenance_delete: 'Sys Delete'
  },
  changeTypeIcon: {
    insert: 'add_circle',
    update: 'cached',
    delete: 'delete',
    maintenance_insert: 'settings',
    maintenance_update: 'settings',
    maintenance_delete: 'settings'
  },
  ui: {
    chart: {
      planned: 'Planned',
      actual: 'Actual',
      noData: 'No data'
    },
    unsavedChanges: 'There are unsaved changes.',
    delete: 'Delete',
    cancel: 'Cancel',
    addProject: {
      title: 'Assign projects to {{name}}',
      roleLabel: 'Assign Role'
    },
    error: {
      parentIsRemoved: 'Parent item has been deleted'
    },
    common: {
      add: 'Add',
      cancel: 'Cancel',
      count: 'items',
      month: 'Month',
      previousMonth: 'Previous Month',
      nextMonth: 'Next Month',
      manMonth: 'Man-Month',
      manDay: 'Man-Day',
      hour: 'Hour',
      plan: 'Plan',
      actual: 'Actual',
      department: 'Department',
      undefinedDepartment: 'Department not set',
      undefinedResource: 'TBD Resource',
      download: 'Download',
      undefined: 'TBD',
      assignStatus: 'Assign Status',
      assignStatusLabel: {
        unplanned: 'No Plan',
        existVolumed: 'Has TBD',
        assigned: 'Assigned'
      },
      all: 'All',
      unknown: 'Unknown',
      inputting: 'Inputting...',
      invalid: 'Invalid',
      reload: 'Reload',
      relogin: 'Re-login',
      ownCompany: 'In-house',
      others: 'Others',
      copy: 'Copy',
      copying: 'Copying...',
      loading: 'Loading...',
      readMore: 'Read More',
      fold: 'Show Less',
      wordJoiner: '',
      total: 'Total',
      edit: 'Edit',
      dragOrder: 'Reorder',
      reset: 'Reset',
      projectName: 'Project Name',
      projectCode: 'Project Code',
      period: 'Period',
      client: 'Client',
      description: 'Description',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      active: 'Active',
      inactive: 'Inactive',
      status: 'Status',
      operation: 'Actions',
      date: 'Date',
      name: 'Name',
      note: 'Note',
      year: '',
      delete: 'Delete',
      asc: 'Ascending',
      desc: 'Descending',
      startDate: 'Start Date',
      endDate: 'End Date',
      fixError: 'Please fix the error',
      noDepartment: 'No Department',
      workType: 'Assign Type',
      namedResource: 'Named Resource',
      volumedResource: 'TBD Resource',
      rangeSeparator: ' ~ '
    },
    router: {
      appTitle: 'Co-Assign Management Tool',
      login: 'Login',
      logout: 'Logout',
      forbidden: 'Permission Denied',
      notFound: 'Page Not Found'
    },
    workerStatus: {
      initializingTitle: 'Preparing',
      initializingMessage: 'Preparing data. Please wait.',
      systemTerminatedTitle: 'System Terminated',
      systemErrorMessage: 'Please re-login to continue.',
      systemErrorTitle: 'System Error',
      unknownTitle: 'Please Wait',
      unknownMessage: 'Please contact us if the issue persists.'
    },
    clientDelete: 'Delete Client',
    targetClient: 'Client to be deleted',
    clientName: 'Client Name',
    warning: {
      cannotRestore: '- Deleted master cannot be restored',
      cannotDeleteUsed: '- Master used in projects cannot be deleted.'
    },
    sideMenu: {
      resource: 'Resources',
      userProject: 'Personnel x Project',
      projectUser: 'Project x Personnel',
      attendance: 'Work Management',
      dataReport: 'Data & Reports',
      settings: 'Settings',
      partner: 'Affiliation',
      changePassword: 'Change Password',
      logout: 'Logout',
      collapse: 'Collapse Sidebar',
      expand: 'Expand Sidebar'
    },
    resetPreferences: {
      title: 'Settings > Reset Settings',
      warning: 'This will reset all settings.',
      warningBold: 'This action cannot be undone.',
      success: 'Settings have been reset.',
      backHome: 'Back to Home'
    },
    forbiddenView: {
      title: 'Access Denied',
      message: 'You do not have permission to view this page.',
      contact: 'If you need permission, please contact the administrator.',
      backHome: 'Back to Home Now'
    },
    userList: {
      assignable: 'Assignable',
      target: 'Target',
      notTarget: 'Not Target',
      add: 'Add Person',
      assignableTooltip: 'Assignable if role is set'
    },

    controlPanel: {
      filter: 'Filter',
      group: 'Group',
      applied: 'Applied'
    },
    user: {
      display_order: 'Display Order',
      name: 'Name',
      email: 'Email',
      role: 'System Role'
    },
    userEdit: {
      titleNew: 'Create User',
      titleEdit: 'Edit User',
      changeSecurity: 'Change security settings',
      forcePasswordChange: 'Force password change',
      resetMFA: 'Reset MFA',
      systemRoleTooltip1:
        'Please note that this is a system permission setting in Co-Assign and differs from internal job titles.',
      systemRoleTooltip2:
        'Functions available depend on the system role.<br />For details, please check the System Role Manual in User Settings on the right.',
      displayOrderTooltip:
        'Specify a number (does not need to be sequential).<br />If left blank, it will be treated as 0 and displayed at the top. Use User Import for batch specification.',
      availableHelp:
        'If unchecked, the user becomes invalid and cannot be assigned to new projects.',
      available: 'Active',
      assignableRole: 'Assignable Roles'
    },
    employmentList: {
      unitPrice: 'Unit Price',
      unitPriceTooltip: 'Setting this allows project cost calculation.',
      addUnitPrice: 'Add Unit Price',
      startMonth: 'Start Month',
      affiliation: 'Affiliation',
      unitPriceType: 'Unit Price Type',
      emptyState: 'Can be set after user registration'
    },
    clientEdit: {
      create: 'Create Client',
      edit: 'Edit Client',
      nameLabel: 'Client'
    },
    projectSummary: {
      headers: {
        target: 'Target',
        plan: 'Plan',
        actual: 'Actual'
      },
      rows: {
        sales: 'Sales',
        cost: 'Cost',
        profit: 'Gross Profit',
        profitRate: 'Gross Margin'
      },
      units: {
        monthly: 'M/M',
        daily: 'Man-Day',
        hourly: 'Man-Hour'
      },
      currency: ' JPY'
    },
    changePassword: {
      newPassword: 'New Password',
      change: 'Change Password',
      success: 'Password changed successfully.',
      fail: 'Failed to change password.',
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPasswordConf: 'New Password (Confirm)',
      newPasswordConfirm: 'New Password (Confirm)',
      submit: 'Change Password',
      messages: {
        success: 'Password updated successfully.',
        failure: 'Failed to update password.',
        mismatch: 'Current password does not match.',
        disabled: 'Password change is not available for your tenant.'
      }
    },
    resetPassword: {
      newPassword: 'New Password',
      newPasswordConf: 'Confirm New Password',
      change: 'Change Password',
      success: 'Password changed successfully.',
      successMessage: 'Password reset has been completed.',
      fail: 'Failed to update password. Please try the password reset again.',
      invalidCode: 'Invalid or expired code. Please try the password reset again.',
      loginLink: 'Return to Login'
    },
    settingEdit: {
      title: 'Settings > System Settings',
      info: 'Configure system-wide settings. Please note that changes are applied immediately.'
    },
    holidayList: {
      title: 'Settings > Holidays',
      regularHoliday: 'Regular & Legal Holidays',
      specifiedList: {
        title: 'Public Holidays, Year-end/New Year, Company Holidays',
        loadBasic: 'Load Standard Holidays',
        add: 'Add Holiday'
      },
      weekdays: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun'
      }
    },
    departmentList: {
      title: 'Settings > Department',
      add: 'Add Department',
      headers: {
        department: 'Department',
        userCount: 'Users',
        projectCount: 'Projects',
        operation: 'Actions'
      }
    },
    clientList: {
      title: 'Settings > Client',
      add: 'Add Client',
      headers: {
        client: 'Client',
        projectCount: 'Projects',
        operation: 'Actions'
      }
    },
    projectSalesAndCost: {
      title: 'Project > Budget Plan',
      pva: 'Plan vs Actual',
      sales: 'Sales',
      cost: 'Cost',
      manCost: 'Labor Cost',
      otherCost: 'Other Cost',
      otherCosts: 'Register Other Costs',
      addOtherCost: 'Add Other Cost',
      manCostPva: 'Plan vs Actual by Personnel',
      resourcePlan: 'Resource Plan',
      salesDistribution: {
        auto: 'Distribute by Month',
        manual: 'Enter Manually'
      },
      projectInfo: {
        code: 'Project Code',
        period: 'Period',
        department: 'Department',
        manager: 'Manager'
      },
      profit: 'Gross Profit',
      profitRate: 'Gross Margin(%)',
      plan: 'Plan',
      actual: 'Actual',
      otherCostDelete: {
        title: 'Delete Other Cost',
        deleteTarget: 'Cost to Delete',
        costName: 'Cost Name',
        deleteWithActualWarning:
          'This item has actual values registered. If deleted, all actual values will also be deleted.',
        deleteWithoutActualWarning: 'Deleted costs cannot be restored'
      }
    },
    projectUser: {
      title: 'Resource Plan > Project x User',
      group: 'Group',
      groups: {
        none: 'None',
        department: 'Department',
        assignStatus: 'Assign Status',
        client: 'Client'
      },
      unspecified: 'Unspecified',
      totalUserCount: 'Headcount',
      totalOperationRate: {
        planRate: 'Planned Utilization Rate',
        planEffortTotal: 'Total Planned Effort',
        filtered: '(Filtered)',
        remaining: 'Remaining',
        show: 'Show',
        calculateTooltip: 'Calculation is paused due to large number of users. Click to calculate.'
      }
    },
    jobSkillList: {
      title: 'Settings > Skill',
      add: 'Add Skill',
      headers: {
        jobSkill: 'Skill',
        userCount: 'Users',
        projectCount: 'Projects',
        status: 'Status',
        operation: 'Actions'
      },
      active: 'Active',
      inactive: 'Inactive'
    },
    jobSkillDelete: {
      title: 'Delete Skill',
      targetJobSkill: 'Skill to Delete',
      jobSkillName: 'Skill Name',
      warning: {
        cannotRestore: '・Deleted master data cannot be restored.',
        cannotDeleteUsed: '・Master data used in projects cannot be deleted.'
      }
    },
    jobSkillEdit: {
      create: 'Create Skill',
      edit: 'Edit Skill',
      nameLabel: 'Skill',
      availableLabel: 'Status',
      availableDescription: 'If unchecked, it becomes invalid and cannot be selected.',
      active: 'Active'
    },
    departmentEdit: {
      create: 'Create Department',
      edit: 'Edit Department',
      nameLabel: 'Department'
    },
    departmentDelete: {
      title: 'Delete Department',
      targetDepartment: 'Department to Delete',
      departmentName: 'Department Name',
      warning: {
        cannotRestore: '・Deleted master data cannot be restored.',
        cannotDeleteUsed: '・Master data used in projects cannot be deleted.'
      }
    },
    partnerEdit: {
      create: 'Create Affiliation',
      edit: 'Edit Affiliation',
      nameLabel: 'Affiliation Name'
    },
    partnerList: {
      title: 'Settings > Affiliation',
      add: 'Add Affiliation',
      headers: {
        partner: 'Affiliation',
        userCount: 'Users',
        operation: 'Actions'
      }
    },
    partnerDelete: {
      title: 'Delete Affiliation',
      targetPartner: 'Affiliation to delete',
      partnerName: 'Affiliation Name',
      warning: {
        cannotRestore: '- Deleted master cannot be restored',
        cannotDeleteUsed: '- Master used in projects cannot be deleted.'
      }
    },
    customFieldList: {
      title: 'Settings > Custom Fields',
      tips: 'Setting custom fields allows you to add unique items to projects.',
      add: 'Add Custom Field',
      headers: {
        name: 'Label',
        key: 'Object Name',
        valueType: 'Data Type',
        description: 'Description',
        required: 'Required',
        visible: 'Status',
        operation: 'Actions'
      },
      placeholders: {
        search: 'Label / Object Name'
      }
    },
    customFieldChoice: {
      label: 'Choices',
      description: 'Set choices for "Single Choice" or "Multiple Choice".',
      add: 'Add Choice',
      headers: {
        name: 'Name',
        key: 'Object Name',
        visible: 'Status',
        operation: 'Actions'
      },
      active: 'Active'
    },
    customFieldEdit: {
      create: 'Create Custom Field',
      edit: 'Edit Custom Field',
      nameLabel: 'Label',
      keyLabel: 'Object Name',
      keyDescription: 'Cannot be changed after registration.',
      typeLabel: 'Data Type',
      addChoiceDescription: 'Please add choices.',
      descriptionLabel: 'Description',
      requiredLabel: 'Required Option',
      requiredDescription: 'If unchecked, it will be an optional field.',
      required: 'Required',
      optional: 'Optional',
      visibleLabel: 'Status',
      visibleDescription: 'If unchecked, it will not be displayed in the project.',
      visible: 'Active'
    },
    jobTitleList: {
      title: 'Settings > Job Title',
      add: 'Add Job Title',
      headers: {
        jobTitle: 'Job Title',
        userCount: 'Users',
        projectCount: 'Projects',
        status: 'Status',
        operation: 'Actions'
      },
      active: 'Active',
      inactive: 'Inactive'
    },
    jobTitleDelete: {
      title: 'Delete Job Title',
      targetJobTitle: 'Job Title to delete',
      jobTitleName: 'Job Title Name'
    },
    jobTitleEdit: {
      create: 'Create Job Title',
      edit: 'Edit Job Title',
      nameLabel: 'Job Title',
      nameWarning: 'Job Title names should not include grades. See "Examples" for details.',
      availableLabel: 'Status',
      availableDescription: 'If unchecked, it becomes invalid and cannot be selected.',
      active: 'Active'
    },
    projectList: {
      title: 'Projects',
      columnSettings: 'Column Settings',
      add: 'Add Project',
      assignStatusTooltip: {
        noPlan: '- No Plan: No assignments for personnel/TBD',
        hasTbd: '- Has TBD: At least one TBD assignment exists',
        assigned: '- Assigned: Only personnel assignments exist'
      },
      salesAndCostPlan: 'Budget Plan',
      sort: {
        targetSales: 'Target Sales(JPY)',
        targetCost: 'Target Cost(JPY)',
        targetManMonth: 'Target Effort (Man-Month)'
      }
    },
    projectDelete: {
      title: 'Delete Project',
      targetProject: 'Project to delete',
      projectName: 'Project Name',
      warning: {
        cannotRestore: 'Deleted project cannot be restored',
        hasWorkResult: 'Work results exist for this project. Clear work results to delete.',
        hasOtherCostActual:
          'Other cost actuals exist for this project. Clear other cost actuals to delete.',
        cannotRestoreProject: 'Deleted project cannot be restored'
      }
    },
    projectCopy: {
      title: 'Copy Project',
      description:
        'Assignments will be copied. *Work results and invalid personnel assignments are not copied.',
      targetProject: 'Project to copy',
      projectName: 'Project Name',
      execute: 'Copy Project',
      copying: 'Copying...',
      goToSource: 'Go to source project',
      error:
        'Copy aborted due to input errors in the project. Please check the source project. Or, duplicate project code exists.'
    },
    projectInfoPanel: {
      projectCode: 'Project Code',
      department: 'Department',
      assignedUser: 'Manager',
      period: 'Period',
      createdAt: 'Registered Date',
      updatedAt: 'Updated Date',
      overview: 'Overview'
    },
    searchChipsDisplay: {
      details: 'Details',
      clear: 'Clear',
      noDepartment: 'No Department'
    },
    noDataText: {
      message: 'No data to display.',
      suggestion: 'You can change the search criteria or "{{action}}".',
      simpleSuggestion: 'You can "{{action}}".'
    },
    noSetting: {
      message: 'No settings available.'
    },
    noHoliday: {
      message: 'No holidays registered.'
    },
    searchBox: {
      projectCode: 'Project Code',
      projectName: 'Project Name',
      department: 'Department',
      manager: 'Manager',
      managerOrDepartment: 'Manager / Department',
      deptUser: 'Dept / Personnel',
      assignedUser: 'Resource',
      jobTitle: 'Role',
      skill: 'Skill',
      endDate: 'End Date',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      projectPeriod: 'Active Period',
      assignStatus: 'Assignment Status',
      keyword: 'Keyword',
      projectStart: 'Project Start Date',
      projectEnd: 'Project End Date',
      client: 'Client',
      name: 'Name',
      email: 'Email',
      systemRole: 'System Role',
      status: {
        unplanned: 'No Plan',
        existVolumed: 'Has TBD',
        assigned: 'Assigned'
      },
      availableLabel: 'Status',
      available: 'Active',
      unavailable: 'Inactive',
      search: 'Search',
      filterPlaceholder: 'Filter Resources',
      clear: 'Clear',
      advancedSearch: 'Advanced Search',
      bothRequired: 'Please select both Assign Type and Role'
    },
    assignColumn: {
      deleted: '(Deleted)',
      invalid: '(Invalid)',
      daySuffix: ' days',
      addResource: 'Add Resource',
      addTbdResource: 'Add TBD Resource',
      tooltip: {
        operation: 'Actions',
        deleteAssign: 'Delete Assignment',
        editAssign: 'Edit Assignment',
        close: 'Close',
        deleteWarning: 'Cannot delete because actual work is registered.',
        editWarning: 'Cannot edit because actual work is registered.'
      },
      modal: {
        assignPeriod: 'Assignment Period',
        fromTo: '〜',
        workTimePerDay: 'Work Time / Day',
        minutesPerDay: 'min / day',
        workTimeRatio: 'Work Time / Ratio',
        percentPerDay: '% / day',
        workTimeTotal: 'Work Time / Total',
        hoursPerDay: 'Hours/Day',
        hoursPerPeriod: 'Hours / Period ({{days}} days)',
        manDaysPerPeriod: 'Man-Days / Period ({{days}} days)',
        manMonthsPerPeriod: 'Man-Months / Period ({{days}} days)',
        manMonthDescription: '1 Man-Month is calculated as fixed 20 business days.',
        close: 'Close',
        delete: 'Delete',
        tbd: 'TBD'
      }
    },
    home: {
      updateInfo: 'Update Information',
      manuals: 'Manuals',
      announcements: 'Announcements'
    },
    jobTrigger: {
      title: 'Job Trigger Management',
      subtitle: 'Job Trigger Table Management (For Developers)',
      warning: 'This page is for developers only. Please modify data with caution.',
      description: 'Manage Job Trigger table data.',
      listDescription: {
        view: 'View Job Trigger List',
        create: 'Create New Job Trigger',
        edit: 'Edit Existing Job Trigger',
        delete: 'Delete Job Trigger (Logical Delete)'
      },
      reload: 'Reload Data',
      jobId: 'Job ID',
      triggerType: 'Trigger Type',
      selectPlaceholder: '-- Please Select --',
      timing: 'Timing',
      timingPlaceholder: {
        periodic: 'Ex: 0 0 * * * (cron expression)',
        email: 'Email settings (optional)',
        default: 'Input execution timing'
      },
      cronExamplePrefix: 'Cron Expression Examples:',
      cronExamples: {
        daily: 'Every day at 0:00',
        every5min: 'Every 5 minutes',
        weekdays: 'Weekdays at 9:00'
      },
      emailDescription: 'Email reception timing setting (optional)',
      triggerTypePeriodicWarning:
        '* Enter cron expression in Timing field (Ex: 0 0 * * * - Every day at 0:00)',
      triggerTypeEmailWarning: '* Automatically executed when email is received',
      params: 'Params (JSON)',
      paramSchema: 'Param Schema',
      formatJson: 'Format JSON',
      claim: 'Claim (JSON)',
      defaultJson: 'Default: {}',
      listTitle: 'Job Trigger List',
      headers: {
        id: 'ID',
        jobId: 'Job ID',
        jobName: 'Job Name',
        triggerType: 'Trigger Type',
        timing: 'Timing',
        params: 'Params',
        claim: 'Claim',
        createdAt: 'Created At',
        operation: 'Actions'
      },
      messages: {
        loadError: 'Failed to load data',
        saveError: 'Failed to save',
        deleteError: 'Failed to delete',
        validationError: 'Validation Error',
        jsonError: 'Invalid JSON format',
        confirmDelete: 'Are you sure you want to delete this Job Trigger? (Logical Delete)'
      }
    },
    addNamedAssign: {
      title: 'Add Named Resource',
      selectUser: 'Please check the resources to add.',
      selectUserForTbd: 'Please check the resource to assign to TBD.',
      filterPlaceholder: 'Filter by Department or Resource Name',
      projectPeriod: 'Project Period: ',
      noDepartment: 'No Department'
    },
    addVolumedAssign: {
      title: 'Add TBD Resource',
      description: 'Select role and skill (optional) to add',
      addMore: 'Add more TBD Resource'
    },
    projectHistory: {
      dateLimit: '* History before 2025-06-30 is not displayed.',
      noHistory: 'No change history.',
      systemUpdate: 'System Update',
      systemUpdateTooltip:
        'Automatically updated to maintain data consistency due to project period changes or maintenance.',
      unknownData: 'Unknown Data',
      deletedData: 'Deleted Data',
      unknownIcon: 'Unknown Icon',
      noData: 'None',
      hoursPerDay: 'Hours/Day',
      manMonth: 'Man-Month',
      currency: '¥'
    },
    jobList: {
      title: 'Data & Reports',
      exportMessages: {
        workResultExported: 'Exported {{count}} work results.'
      },
      jobs: {
        カスタムレポート: {
          name: 'Custom Report',
          description:
            'You can download related user information (username, email, person-months) for each project in a single row with horizontally expanded information in CSV format.'
        },
        'リソースレポート（Ver2）': {
          name: 'Resource Report (Ver2)',
          description:
            'You can download resource status by month for a specified period (planned vs. actual for each project and personnel).'
        },
        'リソースレポート（旧版・26年3月末提供終了予定）': {
          name: 'Resource Report (Legacy Version - Service End Scheduled for March 2026)',
          description:
            'You can download resource status by month for a specified period (planned vs. actual for each project and personnel). The legacy version is scheduled to be discontinued by the end of March 2026, so please switch to Ver2. The data output in Ver2 remains the same (some sheets have column display order changes). We have replaced the array formulas in the "Merge_Reference" sheet with regular cell references to improve performance.'
        },
        プロジェクトインポート: {
          name: 'Project Import',
          description: 'Upload and add/update project data via CSV.',
          params: {
            file: 'Select CSV File'
          }
        },
        プロジェクトエクスポート: {
          name: 'Project Export',
          description:
            'Download a list of projects with end dates newer than 2 years ago in CSV format.'
        },
        人材インポート: {
          name: 'Resource Import',
          description: 'Upload and add/update resources via CSV.',
          params: {
            file: 'Select CSV File'
          }
        },
        人材エクスポート: {
          name: 'Resource Export',
          description: 'Download resource data in CSV format.'
        },
        稼働実績インポート: {
          name: 'Work Result Import',
          description: 'Upload and add/update work results via CSV.',
          params: {
            file: 'Select CSV File',
            target_month: 'Import Month'
          }
        },
        稼働実績エクスポート: {
          name: 'Work Result Export',
          description: 'Download work results in CSV format.',
          params: {
            file: 'Select CSV File',
            target_month: 'Import Month'
          }
        }
      }
    },
    workSheet: {
      title: 'Work Management > Time Sheet',
      table: {
        date: 'Date',
        start: 'Clock In',
        end: 'Clock Out',
        break: 'Break',
        workTime: 'Work Time',
        total: 'Total',
        input: 'Input',
        project: 'Project',
        workTimeSummary: 'Work Time'
      },
      edit: 'Edit',
      inputError: 'There are input errors. Please correct them.',
      noInput: 'No work actuals entered for {{month}}',
      totalWorkTime: 'Total Work Time',
      totalActual: 'Total Actuals'
    },
    workEdit: {
      title: 'Work Input',
      workTime: 'Work Time',
      breakTime: 'Break Time',
      copyFromSpecificDay: 'Copy from Specific Day',
      filter: {
        search: 'Search',
        clear: 'Clear',
        none: 'None',
        entered: 'Entered',
        notEntered: 'Not Entered',
        latest7: {
          label: 'Last 7 Days',
          description: 'Show projects updated in the last 7 days'
        },
        latest30: {
          label: 'Last 30 Days',
          description: 'Show projects updated in the last 30 days'
        }
      },
      table: {
        projectName: 'Project Name',
        projectCode: 'Code',
        role: 'Role',
        comment: 'Comment',
        actualTime: 'Actual Time',
        planTime: 'Planned',
        monthTime: 'Monthly',
        copyPlanTime: 'Copy Planned Time',
        empty: 'No data to display.<br />Please change search criteria or check your assignment.'
      },
      info: {
        formula: 'Work Time - Actual Time = {{label}}',
        unenteredTime: 'Unentered Time',
        exceededTime: 'Exceeded Time',
        workTime: 'Work Time: ',
        actualTime: 'Actual Time: ',
        unenteredTimeLabel: 'Unentered: ',
        exceededTimeLabel: 'Exceeded: ',
        unmatchedTotal: 'Total work time and actual time do not match'
      },
      copyModal: {
        title: 'Copy Work/Actual Time from Specific Day',
        notice:
          '・Currently entered work/actual time will be overwritten.<br />・Work time for projects outside the period will not be copied.',
        sourceDay: 'Source Day: ',
        copy: 'Copy Work/Actual Time',
        errorNoSource: 'Source day is not selected'
      }
    },
    displayPeriod: {
      unit: {
        monthly: 'Monthly',
        monthlySmall: 'Monthly (Small)',
        weekly: 'Weekly',
        daily: 'Daily'
      },
      amount: {
        twoWeeks: '2 Weeks',
        eightWeeks: '8 Weeks',
        nineWeeks: '9 Weeks',
        twelveWeeks: '12 Weeks',
        sixteenWeeks: '16 Weeks',
        oneMonth: '1 Month',
        twoMonths: '2 Months',
        sixMonths: '6 Months',
        nineMonths: '9 Months',
        twelveMonths: '12 Months',
        twentyFourMonths: '24 Months'
      }
    },
    resourcePlan: {
      title: 'Resource Plan',
      userProjectTitle: 'Resource Plan > Personnel x Project',
      summary: 'Sales & Cost Summary',
      salesCost: 'Sales & Cost Plan',
      chart: {
        monthly: 'Monthly (Man-Hours)',
        accumulation: 'Cumulative (Man-Hours)'
      },
      unit: {
        monthly: 'Man-Month',
        daily: 'Man-Day',
        hourly: 'Man-Hour'
      },
      addMember: 'Add Resource',
      addPendingMember: 'Add TBD Resource',
      undefinedStaff: 'TBD Resources',
      undefinedJobTitle: 'TBD Role',
      noDepartment: 'No Department',
      close: 'Close'
    },
    otherCost: {
      createTitle: 'Create Cost',
      editTitle: 'Edit Cost',
      name: 'Cost Name',
      newCost: 'New Cost',
      total: 'Total',
      currency: 'JPY',
      syncWithPlan: 'Set actual value to same as plan',
      plan: 'Plan'
    },
    projectEdit: {
      createTitle: 'Create Project',
      editTitle: 'Edit Project',
      name: 'Project Name',
      period: 'Project Period',
      code: 'Project Code',
      client: 'Client',
      description: 'Description',
      costManagement: 'Cost Management',
      costManagementDesc: 'Enables cost rate calculation in Resource Plan.',
      targetSales: 'Target Sales(JPY)',
      targetCost: 'Target Cost(JPY)',
      targetManHours: 'Target Man-Hours',
      currency: 'JPY',
      manMonth: 'Man-Month',
      member: 'Members',
      memberDesc: 'Assigned resources can modify the project',
      department: 'Department',
      invalidItemIncluded: 'Contains invalid items'
    },
    planActualMode: {
      plan: 'Plan',
      actual: 'Actual'
    },
    jobDetail: {
      manual: 'Manual',
      unsavedJobWarning:
        'This job cannot be executed because it has not been saved yet. Please save it to execute.',
      execute: 'Execute',
      executedMessage: 'Executed. The job execution result will be displayed below.',
      error: {
        invalidFile: 'Invalid file selected.',
        general: 'An error occurred.',
        fileReadFail: 'Failed to read file'
      }
    },
    customFieldNames: {
      order_probability: 'Order Probability'
    },
    resetMFA: {
      title: 'Reset MFA',
      description1: 'Reset multi-factor authentication for the selected user.',
      description2: 'After reset, MFA registration will be required again upon next login.',
      reset: 'Reset MFA',
      success: 'MFA has been reset.',
      fail: 'Failed to reset. Please try again.'
    },
    dashboard: {
      title: 'Personnel Dashboard',
      userInfo: 'Personnel Information',
      workStatus: 'Work Status',
      performanceDetails: 'Performance Details',
      assignmentPlan: 'Assignment Plan',
      actualStatus: {
        project: 'Project',
        role: 'Role',
        planned: 'Planned (h)',
        actual: 'Actual (h)'
      },
      assignStatus: {
        project: 'Project',
        assignStart: 'Assign Start',
        assignEnd: 'Assign End',
        status: 'Status',
        plannedEffort: 'Planned Effort (h)',
        actualEffort: 'Actual Effort (h)',
        statusPlanned: 'Planned',
        statusInProgress: 'In Progress',
        statusCompleted: 'Completed'
      }
    },
    employment: {
      create: 'Create Contract',
      edit: 'Edit Contract',
      startMonth: 'Start Month',
      amount: 'Amount',
      costType: 'Cost Type',
      defaultCostStartMonthUnchangeable: 'The start month of the default rate cannot be changed.',
      currency: 'JPY'
    },
    volumedAssign: {
      undefinedResourceEffortTotal: 'TBD Resource Effort Total'
    },
    assignedJobtitle: {
      undefined: 'TBD',
      addAssignment: '[+Assign]',
      department: 'Department',
      skill: 'Skill'
    },
    tooltip: {
      projectName: 'Project Name',
      projectCode: 'Project Code',
      period: 'Period',
      role: 'Role',
      clientName: 'Client Name'
    },
    stageDeleteModal: {
      title: 'Discard Changes',
      warning: 'Discarded changes cannot be undone',
      confirmation: 'All changes will be discarded. Are you sure?',
      discard: 'Discard'
    },
    userDetail: {
      title: 'Personnel Details',
      edit: 'Edit',
      email: 'Email Address',
      department: 'Department',
      jobTitle: 'Job Title',
      skill: 'Skill',
      assignStatus: 'Assignment Status',
      assignedProjects: 'Assigned Projects',
      projectSearchPlaceholder: 'Project Name / Project Code / Client Name',
      projectName: 'Project Name',
      projectCode: 'Project Code',
      period: 'Period',
      client: 'Client'
    },
    jobResults: {
      loading: 'Loading...',
      started: 'Started',
      ended: 'Ended',
      executionLog: 'Execution Log'
    }
  },
  login: {
    email: 'Email Address',
    password: 'Password',
    loginButton: 'Login',
    forgotPassword: 'Forgot Password?',
    smallDeviceMessage:
      'This service only supports work management features on devices with small screens.',
    mfaCodeInput: 'Enter Security Code',
    mfaCodeDescription: 'Enter the 6-digit code displayed in your Authenticator app',
    mfaSubmit: 'Authenticate',
    accountConnected: 'Your account is linked with {{provider}}.',
    loginWith: 'Login with {{provider}}',
    or: 'or',
    mfaRegistrationTitle: 'Two-Factor Authentication Setup',
    mfaStep1Description: 'Install one of the following Authenticator apps on your mobile device.',
    mfaStep2Description: 'Scan the QR code below with your Authenticator app.',
    mfaStep3Description: 'Enter the 6-digit code displayed in your Authenticator app.',
    mfaSecretCodeLabel: 'Secret Code:',
    mfaRetryLink: 'Go back to login screen',
    invalidCredentials: 'Email address or password is incorrect.',
    tooManyRequests: 'Too many attempts. Please try again later.',
    userDisabled: 'This user has been disabled. Please contact the administrator.',
    defaultErrorMessage: 'Login failed.',
    invalidMfaCode: 'Authentication code is incorrect. Please try again.',
    timeoutError: 'Timeout error. Please try logging in again from the login screen.'
  },
  forgetPassword: {
    title: 'Send password reset URL.',
    description: 'Please enter the registered email address.',
    email: 'Email address',
    sendButton: 'Send email',
    backToLogin: 'Back to login screen',
    successMessage: 'An email with the password reset URL has been sent.',
    emailError: 'Please enter a valid email address',
    accountNotFound: 'Account not found.',
    systemError: 'A system error has occurred. Please try again later.'
  },
  notFound: {
    title: 'Page Not Found',
    titleShort: '404 Not Found',
    message: 'The page you are looking for was not found',
    description: 'The URL might be incorrect, or the page may have been moved or deleted.',
    support: 'If you continue to have issues, please contact the administrator.',
    homeButton: 'Go back to home now',
    genericError: 'Error'
  },
  validation: {
    REQUIRED: 'Required',
    INVALID_DATE: 'Please enter a valid date (YYYY-MM-DD).',
    INVALID_ALPHANUMERIC: 'Please enter alphanumeric characters and symbols',
    END_DATE_AFTER_START_DATE: 'End date must be after start date',
    WITHIN_5_YEARS: 'Period must be within 5 years',
    WORK_RESULT_OUTSIDE_PERIOD: 'Work results exist outside the period',
    CODE_EXISTS: 'That code is already in use',
    MAX_30_ITEMS: 'Must be 30 items or less',
    MAX_30_USERS: 'Must be 30 users or less',
    MAX_10_DEPARTMENTS: 'Must be 10 departments or less',
    attendance: {
      lessThan3600: 'Maximum time is 35:59',
      startBeforeEnd: 'Start time must be before end time',
      withinWorkingHours: 'Time must be within working hours',
      overlapBreak: 'Break times overlap'
    }
  }
}
